import {
  fork,
  take,
  put,
  call
} from 'redux-saga/effects'
import * as apiOutlet from 'api/outlets'
import * as apiProfile from 'api/profile'
import {initialize} from 'redux-form'
import {
  SETTING_RECEIPT_CHANGE_OUTLET,
  SETTING_RECEIPT_PAGE_REQUEST,
  SETTING_RECEIPT_SUBMIT_FORM,
  SETTING_RECEIPT_CHANGE_OUTLET_NAME,
  SETTING_RECEIPT_CHANGE_PAGE
} from 'actions/setting/receipt/constants'
import * as action from 'actions/index'
import * as actOutlet from 'actions/outlet'
import * as actNotif from 'actions/notifications'
import * as actReceipt from 'actions/setting/receipt'
import * as apiLogin from 'api/login'
import {phoneNumberFormatter} from 'utils/formatter'
import * as mpSettingReceipt from 'mixpanel/settings/receipt'

export function * fillForm (currentOutlet) {
  let {name, address, city, province, postal_code, notes, phone_number} = currentOutlet
  yield put(initialize('checkout', {
    name,
    address,
    city,
    province,
    zipcode: postal_code,
    phone: phoneNumberFormatter(phone_number),
    notes
  }, false))
}

export function * fillSearchForm (outletIds) {
  yield put(initialize('search', {
    outlet: outletIds
  }))
}

export function * pageRequestFlow () {
  yield take(SETTING_RECEIPT_PAGE_REQUEST)
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showProgressBar())

    let outletRes = yield call(apiOutlet.outlets)
    let outlets = outletRes.data
    yield put(actReceipt.setOutlets(outlets))

    let currentProfileRes = yield call(apiProfile.getProfile)
    let currentProfile = currentProfileRes.data
    yield put(actOutlet.setCurrentOutlet(currentProfile))
    yield put(actReceipt.setProfile(currentProfile))

    yield call(fillForm, currentProfile.selected_outlets[0])
    // only assign first outlet, if > 0 because it means select all outlet
    yield call(fillSearchForm, [currentProfile.outlet_id[0]])
    mpSettingReceipt.settingReceiptStart({outletIds: [currentProfile.outlet_id[0]]})
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}

export function * changeOutletFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {outletIds}} = yield take(SETTING_RECEIPT_CHANGE_OUTLET)
    mpSettingReceipt.settingReceiptChangeOutlet({outletIds})
    try {
      yield put(action.sendingRequest(true))
      yield put(action.showProgressBar())

      yield call(apiLogin.loginOutlet, {id: outletIds})
      let currentProfileRes = yield call(apiProfile.getProfile)
      let currentProfile = currentProfileRes.data
      yield put(actOutlet.setCurrentOutlet(currentProfile))
      yield put(actReceipt.setProfile((currentProfile)))

      yield call(fillForm, currentProfile.selected_outlets[0])
      yield call(fillSearchForm, outletIds)

      let outletsRes = yield call(apiOutlet.outlets)
      let outlets = outletsRes.data
      yield put(actOutlet.setOutlets(outlets))
    } finally {
      yield put(action.sendingRequest(false))
      yield put(action.hideProgressBar())
    }
  }
}

export function * changeOutletNameFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {outlets, currentProfile, name}} = yield take(SETTING_RECEIPT_CHANGE_OUTLET_NAME)
    outlets.forEach((outlet) => {
      if (outlet.id === currentProfile.selected_outlets[0].id) {
        outlet.name = name
        currentProfile.selected_outlets[0].name = name
      }
    })
    yield put(actOutlet.setCurrentOutlet(currentProfile))
    yield put(actOutlet.setOutlets(outlets))
    yield put(actReceipt.setProfile(currentProfile))
  }
}

export function * submitFormFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {data, outletId}} = yield take(SETTING_RECEIPT_SUBMIT_FORM)
    try {
      yield put(action.sendingRequest(true))
      yield put(action.showProgressBar())
      yield call(apiOutlet.putOutletById, outletId, data, {})
      yield put(actNotif.success('Outlet was successfully updated.'))
      // call get profile again and then reinitialize the form
      let outletRes = yield call(apiOutlet.outlets)
      let outlets = outletRes.data
      yield put(actReceipt.setOutlets(outlets))

      let currentProfileRes = yield call(apiProfile.getProfile)
      let currentProfile = currentProfileRes.data
      yield put(actOutlet.setCurrentOutlet(currentProfile))
      yield put(actReceipt.setProfile(currentProfile))

      yield call(fillForm, currentProfile.selected_outlets[0])
      // only assign first outlet, if > 0 because it means select all outlet
      yield call(fillSearchForm, [currentProfile.outlet_id[0]])
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(action.sendingRequest(false))
      yield put(action.hideProgressBar())
    }
  }
}

export function * changePageFlow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {nextLocation}} = yield take(SETTING_RECEIPT_CHANGE_PAGE)
    // temporary cheat - not using browserHistory
    window.location.href = nextLocation
    // browserHistory.push(nextLocation)
  }
}

export default function * settingReceiptFlowSaga () {
  yield fork(changeOutletFlow)
  yield fork(pageRequestFlow)
  yield fork(submitFormFlow)
  yield fork(changeOutletNameFlow)
  yield fork(changePageFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/setting/receipt.js